import { render, staticRenderFns } from "./BanjiamiaoshaGood.vue?vue&type=template&id=18fb2ca9&scoped=true"
import script from "./BanjiamiaoshaGood.vue?vue&type=script&lang=js"
export * from "./BanjiamiaoshaGood.vue?vue&type=script&lang=js"
import style0 from "./BanjiamiaoshaGood.vue?vue&type=style&index=0&id=18fb2ca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb2ca9",
  null
  
)

export default component.exports